/**
 * Media belongs on the property record (via getPublicProperty), not in calculation / DealLens payloads.
 */

/** Top-level calculation keys that must never be persisted. */
export const CALCULATION_MEDIA_KEYS = ["photos", "video_link", "virtual_tour_link", "share_photos_data"];

/**
 * Removes media fields from a calculation object. Safe for load paths (legacy DB rows)
 * and save paths (organic writes persist a clean shape).
 *
 * @param {unknown} calculation
 * @returns {object|null}
 */
export function sanitizeCalculationMedia(calculation) {
  if (!calculation || typeof calculation !== "object" || Array.isArray(calculation)) {
    return calculation && typeof calculation === "object" ? calculation : null;
  }

  const sanitized = { ...calculation };

  for (const key of CALCULATION_MEDIA_KEYS) {
    delete sanitized[key];
  }

  return sanitized;
}
